// goods
const MqlMiddlePage = () => import('@components/core/MqlLayout/MqlMiddlePage/index')
// const goodsCardType = () => import('@views/home/goods/goodsCardType/index')
// const goodsProduct = () => import('@views/home/goods/goodsProduct/index')

// const goodsProductEdit = () => import('@views/home/goods/goodsProduct/goodsProductEdit/index')
// const goodsProductRoyalty = () => import('@views/home/goods/goodsProduct/goodsProductRoyalty/index')
const index = () => import('@views/home/index/index')

const routes = [
  {
    path: '/goods',
    component: index,
    redirect: { name: 'homeGoodsItemsList' },
    name: 'goods',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '商品管理',
      icon: 'goods_manage',
      first: true,
      resourceCode: 'GOODS_MANAGE',
      No: 5
    },
    children: [
      {
        path: 'item',
        component: MqlMiddlePage,
        name: 'homeGoodsItemsList',
        redirect: { name: 'goodsItemsList' },
        meta: {
          keepAlive: true,
          title: '项目',
          second: false,
          resourceCode: 'GOODS_MANAGE01',
          No: 0
        },
        children: [
          {
            path: 'list',
            component: () => import('@views/home/goods/goodsItems/goodsItemsList/index'),
            name: 'goodsItemsList',
            meta: { keepAlive: true, title: '项目列表' }
          },
          {
            path: 'info',
            component: () => import('@views/home/goods/goodsItems/goodsItemsEdit/index'),
            name: 'homeGoodsItemsAdd',
            meta: { keepAlive: true, title: '基本信息' }
          },
          {
            path: 'royalty',
            component: () => import('@views/home/goods/goodsItems/goodsItemsRoyalty/index'),
            name: 'homeGoodsItemsRoyaltyAdd',
            meta: { keepAlive: true, title: '提成设置' }
          }
        ]
      },
      {
        path: 'goods',
        component: MqlMiddlePage,
        name: 'goodsCard',
        redirect: { name: 'goodsCardTypeList' },
        meta: {
          keepAlive: true,
          title: '卡项',
          second: false,
          resourceCode: 'GOODS_MANAGE02',
          No: 1
        },
        children: [
          {
            path: 'list',
            component: () => import('@views/home/goods/goodsCardType/goodsCardTypeList/index'),
            name: 'goodsCardTypeList',
            meta: { keepAlive: true, title: '卡项列表' }
          },
          {
            path: 'edit',
            component: () => import('@views/home/goods/goodsCardType/goodsCardTypeEdit/index'),
            name: 'goodsCardTypeEdit',
            meta: { keepAlive: true, title: '添加卡项' }
          },
          {
            path: 'royalty',
            component: () => import('@views/home/goods/goodsCardType/goodsCardTypeRoyalty/index'),
            name: 'goodsCardTypeRoyalty',
            meta: { keepAlive: true, title: '编辑卡项' }
          },
          {
            path: 'commission',
            component: () =>
              import('@views/home/goods/goodsCardType/goodsCardTypeCommission/index'),
            name: 'goodsCardTypeCommission',
            meta: { keepAlive: true, title: '编辑卡项' }
          }
        ]
      },
      {
        path: 'product',
        component: MqlMiddlePage,
        name: 'homeGoodsProductList',
        redirect: { name: 'goodsProductList' },
        meta: {
          keepAlive: true,
          title: '产品',
          second: false,
          resourceCode: 'GOODS_MANAGE03',
          No: 2
        },
        children: [
          {
            path: 'list',
            component: () => import('@views/home/goods/goodsProduct/goodsProductList/index'),
            name: 'goodsProductList',
            meta: { keepAlive: true, title: '产品列表' }
          },
          {
            path: 'edit',
            component: () => import('@views/home/goods/goodsProduct/goodsProductEdit/index'),
            name: 'goodsProductEdit',
            meta: { keepAlive: true, title: '添加产品' }
          },
          {
            path: 'royalty',
            component: () => import('@views/home/goods/goodsProduct/goodsProductRoyalty/index'),
            name: 'goodsProductRoyalty',
            meta: { keepAlive: true, title: '提成设置' }
          }
        ]
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/goods.js